import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
} from '@angular/core';
import { IconComponent } from '@rivet-health/design-system';
import { AnalyticsEventOutput } from '../analytics/common-analytics.service';
import { MenuContext, MENU_CONTEXT_TOKEN } from './menu-context';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: '[menuItem]',
  styleUrls: ['./menu-item.component.scss'],
  templateUrl: './menu-item.component.html',
})
export class MenuItemComponent {
  @Input() icon: IconComponent.Name;

  @HostBinding('class.locked')
  @Input()
  locked: boolean;

  @Input()
  showLockedIcon: boolean = true;

  @Input()
  closeOnClick: boolean = true;

  @Input()
  readonly analyticsEvents: {
    click?: AnalyticsEventOutput<void>;
  } = {};

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(MENU_CONTEXT_TOKEN)
    private readonly menuContext: MenuContext,
    private readonly element: ElementRef<HTMLElement>,
  ) {}

  @HostListener('click', ['$event'])
  click(event: Event) {
    event.stopPropagation();
    if (this.closeOnClick) {
      this.menuContext.closeMenu(true);
    }
    if (this.analyticsEvents.click) {
      this.analyticsEvents.click();
    }
  }

  get focused() {
    return this.document.activeElement === this.element.nativeElement;
  }

  focus() {
    this.element.nativeElement.focus();
  }
}
